import React from "react";

/**
 * Reusable input wrapper with overline label + optional left icon.
 * Pass the actual <input> as children (apply `pl-10` if using an icon).
 */
export default function Field({ label, icon: Icon, children, className = "" }) {
  return (
    <label className={`block ${className}`}>
      <div className="overline text-[var(--ink-soft)] mb-2">{label}</div>
      <div className="relative">
        {Icon && (
          <Icon
            size={18}
            weight="duotone"
            className="absolute left-3 top-1/2 -translate-y-1/2 text-[var(--ink-soft)]"
          />
        )}
        {children}
      </div>
    </label>
  );
}
